module.exports = "<a [routerLink]='[\"/reverse-lookup\"]' class=\"nav-link\" (click)=\"logout()\">\r\n  Logout\r\n</a>\r\n"